import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import { useTranslate } from "ra-core";
import { useRenameFileSystemNodeDialog } from "../dialogs/rename-file-system-node-dialog/RenameFileSystemNodeDialogProvider";

const RenameFileSystemNodeButton = (props) => {
    const { onClick, fileSystemNodePath } = props;
    const translate = useTranslate();
    const dialog = useRenameFileSystemNodeDialog();
    const handleOnClick = () => {
        dialog.open(fileSystemNodePath);
        onClick();
    }
    return (
        <ListItem button onClick={handleOnClick}>
            <ListItemIcon>
                <EditIcon/>
            </ListItemIcon>
            <ListItemText primary={translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.rename`)} />
        </ListItem>
    ) 
};
export default RenameFileSystemNodeButton;
